export default __webpack_public_path__ + "static/media/logo-edge.249be5fb.svg";